import NewsCard from '@leuven2030/food/News/NewsCard';
import 'twin.macro';
import React, { FC, useContext } from 'react';
import { NewsContext } from '@leuven2030/food/News/NewsProvider';
import { useRouter } from 'next/router';

const NewsCardGrid: FC<{
  edges?: any[];
}> = ({ edges, ...props }) => {
  const { filteredResults } = useContext(NewsContext);
  const router = useRouter();
  if (!router.isReady) {
    return <></>;
  }

  return (
    <div tw="grid gap-12 md:grid-cols-2 xl:grid-cols-3" {...props}>
      {(edges || filteredResults).map(({ node }) => (
        <NewsCard key={node._meta.uid} {...node} />
      ))}
    </div>
  );
};

export default NewsCardGrid;
